import { render, staticRenderFns } from "./us.vue?vue&type=template&id=b8d2ddf2&scoped=true&"
import script from "./us.vue?vue&type=script&lang=js&"
export * from "./us.vue?vue&type=script&lang=js&"
import style0 from "./us.vue?vue&type=style&index=0&id=b8d2ddf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d2ddf2",
  null
  
)

export default component.exports